<template>
  <div>
    <div class="indicatorTitle" >
      {{ year }}
    </div>
    <div class="indicatorTitle">
      {{ indicator }}
    </div>
    <div class="indicatorTitle">
      View by: {{ viewBy }}
    </div>
    <div class="indicatorTitle">
      Response: {{ response }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  // computed: {
  //   ...mapState({
  //     compareId: state => state.LP.stratFilters.compareId,
  //     ageId: state => state.LP.stratFilters.ageId,
  //     genderId: state => state.LP.stratFilters.genderId,
  //     raceId: state => state.LP.stratFilters.raceId,
  //     riskFactorId: state => state.LP.stratFilters.riskFactorId,
  //     riskFactorResponseId: state => state.LP.stratFilters.riskFactorResponseId,
  //     view: state => state.LP.view,
  //   }),
  //   ...mapGetters([
  //     'indicator',
  //     'compare',
  //     'year',
  //     'response',
  //     'responseLabel',
  //     'age',
  //     'gender',
  //     'race',
  //     'riskFactor',
  //     'riskFactorResponse',
  //     'dataValueType',
  //   ]),
  //   ageGenderRaceFiltersDescription() {
  //     const desc = [];
  //     if (this.ageId) desc.push(`Age Group: ${this.age}`);
  //     if (this.genderId) desc.push(`Gender: ${this.gender}`);
  //     if (this.raceId) desc.push(`Race/Ethnicity: ${this.race}`);
  //     return desc.join('; ');
  //   },
  //   riskFactorFiltersDescription() {
  //     const desc = [];
  //     if (this.riskFactorId) desc.push(`Risk Factor: ${this.riskFactor}`);
  //     if (this.riskFactorResponseId) desc.push(`Risk Factor Response: ${this.riskFactorResponse}`);
  //     return desc.join('; ');
  //   },
  // },
  props: {
    filterState: {
      type: Object,
      default() {
        return {
          yearId: '',
          stratCatId1: '',
          stratId1: '',
          stratCatId2: '',
          stratId2: '',
          responseId: '',
          dataValueTypeId: '',
        };
      },
    },
  },
  computed: {
    ...mapState({
      lku: state => state.lku,
      GSGo: state => state.LP.GSGo,
      indicatorId: state => state.LP.indicatorId,
      stratFilters: state => state.LP.stratFilters,
      dataTypes: state => state.dataTypes,
    }),
    year() {
      return this.stratFilters.yearId ? this.lku.Year[this.stratFilters.yearId].name : '';
      // return '2016 - hard coded';
    },
    indicator() {
      return this.indicatorId ? this.lku.Question[this.indicatorId].name : '';
    },
    viewBy() {
      if (this.stratFilters.stratCatId1 === process.env.OverallStratCatId) {
        return this.stratFilters.stratCatId1 ? this.lku.StratificationCategory[this.stratFilters.stratCatId1].name : '';
      }
      const stratCat1 = this.stratFilters.stratCatId1 ? `  ${this.lku.StratificationCategory[this.stratFilters.stratCatId1].name}` : '';
      const strat1 = this.stratFilters.stratId1 ? ` -  ${this.lku.Stratification[this.stratFilters.stratId1].name}` : '';
      const stratCat2 = this.stratFilters.stratCatId2 ? `; ${this.lku.StratificationCategory[this.stratFilters.stratCatId2].name}` : '';
      const strat2 = this.stratFilters.stratId2 ? ` -  ${this.lku.Stratification[this.stratFilters.stratId2].name}` : '';
      return `${stratCat1}${strat1}${stratCat2}${strat2}`;
      // return 'test - hard coded';
    },
    response() {
      return this.stratFilters.responseId ? this.lku.Response[this.stratFilters.responseId].name : 'All';
    },
  },
};
</script>

<style scoped>
  h3 {
    margin-top: 10px;
    margin-bottom: 0;
  }

  .larger {
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/LP/VisualizationTitle.vue